<template>
  <form class="helpdesk-form" @submit.prevent="submit">
    <div class="form-row">
      <label :for="ids.subject">موضوع</label>
      <input
        :id="ids.subject"
        v-model.trim="form.name"
        type="text"
        maxlength="255"
        required
        placeholder="مثلاً مشکل ورود به حساب"
      >
    </div>
    <div class="form-row">
      <label :for="ids.priority">اولویت</label>
      <select :id="ids.priority" v-model="form.priority">
        <option value="0">کم</option>
        <option value="1">متوسط</option>
        <option value="2">زیاد</option>
        <option value="3">فوری</option>
      </select>
    </div>
    <div class="form-row">
      <label :for="ids.body">شرح درخواست</label>
      <textarea
        :id="ids.body"
        v-model="form.description"
        rows="6"
        required
        placeholder="مشکل را با جزئیات بنویسید."
      ></textarea>
    </div>
    <p v-if="error" class="helpdesk-error">{{ error }}</p>
    <button class="helpdesk-submit" type="submit" :disabled="saving">
      {{ saving ? 'در حال ارسال...' : 'ثبت تیکت' }}
    </button>
  </form>
</template>

<script>
export default {
  name: 'HelpdeskTicketForm',
  props: {
    saving: {
      type: Boolean,
      default: false,
    },
    idPrefix: {
      type: String,
      default: 'helpdesk',
    },
  },
  data() {
    return {
      error: '',
      form: {
        name: '',
        description: '',
        priority: '1',
      },
    }
  },
  computed: {
    ids() {
      const prefix = this.idPrefix || 'helpdesk'
      return {
        subject: `${prefix}-subject`,
        priority: `${prefix}-priority`,
        body: `${prefix}-body`,
      }
    },
  },
  methods: {
    submit() {
      this.error = ''
      const name = (this.form.name || '').trim()
      const description = (this.form.description || '').trim()
      if (!name || !description) {
        this.error = 'موضوع و شرح تیکت لازم است.'
        return
      }
      this.$emit('submit', {
        name,
        description,
        priority: this.form.priority,
      })
    },
    reset() {
      this.form.name = ''
      this.form.description = ''
      this.form.priority = '1'
      this.error = ''
    },
  },
}
</script>

<style scoped>
.helpdesk-form {
  display: grid;
  gap: 14px;
}

.form-row {
  display: grid;
  gap: 6px;
}

.form-row label {
  font-size: 13px;
  font-weight: 700;
  color: #1e1e1e;
}

.form-row input,
.form-row select,
.form-row textarea {
  width: 100%;
  border: 1px solid #ead7dc;
  border-radius: 14px;
  padding: 12px 14px;
  font-size: 14px;
  background: #fff;
  color: #1e1e1e;
  outline: none;
}

.form-row textarea {
  resize: vertical;
  min-height: 140px;
}

.form-row input:focus,
.form-row select:focus,
.form-row textarea:focus {
  border-color: #eb3d60;
  box-shadow: 0 0 0 3px rgba(235, 61, 96, 0.12);
}

.helpdesk-submit {
  justify-self: start;
  border: 0;
  border-radius: 999px;
  background: #eb3d60;
  color: #fff;
  font-weight: 700;
  padding: 12px 22px;
  cursor: pointer;
}

.helpdesk-submit:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.helpdesk-error {
  margin: 0;
  color: #b42318;
  font-size: 13px;
}
</style>
